import React from "react";

// Valores fixos (não `Math.random`) para o confete não trocar de posição a cada
// re-render — com aleatório, qualquer atualização de estado faria as peças saltarem
// no meio da queda.
const PECAS = [
  { left: "4%", cor: "#fbbf24", dur: "2.6s", atraso: "0s", giro: "540deg" },
  { left: "12%", cor: "#f472b6", dur: "3.1s", atraso: "0.15s", giro: "380deg" },
  { left: "20%", cor: "#38bdf8", dur: "2.4s", atraso: "0.3s", giro: "620deg" },
  { left: "28%", cor: "#4ade80", dur: "3.4s", atraso: "0.05s", giro: "450deg" },
  { left: "36%", cor: "#fb923c", dur: "2.8s", atraso: "0.4s", giro: "700deg" },
  { left: "44%", cor: "#c084fc", dur: "3.0s", atraso: "0.2s", giro: "400deg" },
  { left: "52%", cor: "#fbbf24", dur: "2.5s", atraso: "0.35s", giro: "560deg" },
  { left: "60%", cor: "#38bdf8", dur: "3.3s", atraso: "0.1s", giro: "480deg" },
  { left: "68%", cor: "#f472b6", dur: "2.7s", atraso: "0.25s", giro: "620deg" },
  { left: "76%", cor: "#4ade80", dur: "3.2s", atraso: "0.45s", giro: "520deg" },
  { left: "84%", cor: "#fb923c", dur: "2.9s", atraso: "0.05s", giro: "640deg" },
  { left: "92%", cor: "#c084fc", dur: "2.6s", atraso: "0.3s", giro: "440deg" },
  { left: "8%", cor: "#38bdf8", dur: "3.5s", atraso: "0.5s", giro: "500deg" },
  { left: "16%", cor: "#fbbf24", dur: "2.3s", atraso: "0.15s", giro: "460deg" },
  { left: "32%", cor: "#f472b6", dur: "3.0s", atraso: "0.4s", giro: "600deg" },
  { left: "48%", cor: "#4ade80", dur: "2.5s", atraso: "0.1s", giro: "520deg" },
  { left: "64%", cor: "#fb923c", dur: "3.1s", atraso: "0.35s", giro: "580deg" },
  { left: "80%", cor: "#c084fc", dur: "2.7s", atraso: "0.2s", giro: "460deg" }
];

/* A peça mais lenta leva 3,5s e a última só começa em 0,5s. Quem monta o confete
   usa isto para desmontá-lo na hora certa: mais cedo corta a queda no meio, mais
   tarde deixa 18 elementos parados no DOM. */
export const DURACAO_DO_CONFETE_MS = 4000;

/**
 * Chuva de confete sobre a tela.
 *
 * Saiu de `CerimoniaCard.jsx` em 05/08/2026, quando o encerramento passou a ter o
 * próprio momento de chegada — até então a tela final era mais calada que uma
 * revelação do meio do caminho, que tem confete e baú estourando em luz.
 *
 * ONDE ELE CAI depende de quem o monta, e isso não é acidente. O CSS usa
 * `position: fixed`, que se mede pela viewport — a não ser que algum ancestral
 * tenha `transform`, e aí passa a se medir por ele. Na cerimônia o confete vive num
 * portal e cobre a tela toda; no encerramento o palco tem `translateZ(0)` (a regra
 * que conserta a barra de rolagem), então a chuva fica contida na área da trilha. É
 * o comportamento desejado nos dois casos: espalhar confete pela página inteira do
 * AVA, por cima do menu e da barra lateral, seria invasivo.
 *
 * `aria-hidden` porque é decoração pura: não há o que anunciar, e 18 spans vazios
 * na árvore de acessibilidade só atrapalhariam.
 */
function Confete() {
  return (
    <div className="trilha-ludica__confete" aria-hidden="true">
      {PECAS.map((peca, indice) => (
        <span
          key={indice}
          className={`trilha-ludica__confete-peca${
            indice % 3 === 0 ? " trilha-ludica__confete-peca--redondo" : ""
          }`}
          style={{
            "--tl-confete-left": peca.left,
            "--tl-confete-cor": peca.cor,
            "--tl-confete-dur": peca.dur,
            "--tl-confete-atraso": peca.atraso,
            "--tl-confete-giro": peca.giro
          }}
        />
      ))}
    </div>
  );
}

export default Confete;
